<template>
  <div class="page-content">
    <div class="page-title">Youth roadmap for associations and clubs for UNESCO 2025 –2030</div>
    <iframe class="pdf-iframe" src="/Youth roadmap for associations and clubs for UNESCO 2025 –2030.pdf" frameborder="0" scrolling="no" style="display: block;"></iframe>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
